import React, { Component } from 'react'
import { AUTH_TOKEN, SELECTED_BRANCH, HOOK_URL, OCI } from '../../constants'

import Footer from '../../components/Footer/'
import Error from '../../components/Error'

import logo from '../../assets/logo.svg'
import desert from '../../assets/hero/login/desert.jpg'
import desertMobile from '../../assets/hero/login/desert-mobile.jpg'
import rock from '../../assets/hero/login/rock.jpg'
import rockMobile from '../../assets/hero/login/rock-mobile.jpg'
import sea from '../../assets/hero/login/sea.jpg'
import seaMobile from '../../assets/hero/login/sea-mobile.jpg'
import snow from '../../assets/hero/login/snow.jpg'
import snowMobile from '../../assets/hero/login/snow-mobile.jpg'

import { Container, Logo } from './styles'

class Logout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showBranches: false,
      hero: this.generateRandomImage(),
    }
  }

  componentDidMount() {
    let reload = false

    if (window.localStorage.getItem(AUTH_TOKEN)) {
      window.localStorage.removeItem(AUTH_TOKEN)
      reload = true
    } else if (window.sessionStorage.getItem(AUTH_TOKEN)) {
      window.sessionStorage.removeItem(AUTH_TOKEN)
      reload = true
    }
    if (window.localStorage.getItem(SELECTED_BRANCH)) {
      window.localStorage.removeItem(SELECTED_BRANCH)
      reload = true
    } else if (window.sessionStorage.getItem(SELECTED_BRANCH)) {
      window.sessionStorage.removeItem(SELECTED_BRANCH)
      reload = true
    }
    if (window.sessionStorage.getItem(HOOK_URL)) {
      window.sessionStorage.removeItem(HOOK_URL)
      reload = true
    }
    if (window.sessionStorage.getItem(OCI)) {
      window.sessionStorage.removeItem(OCI)
      reload = true
    }
    
    if (reload) {
      window.location.reload()
    }
  }

  generateRandomImage() {
    let images = [
      {
        desktop: desert,
        mobile: desertMobile
      },
      {
        desktop: rock,
        mobile: rockMobile
      },
      {
        desktop: sea,
        mobile: seaMobile
      },
      {
        desktop: snow,
        mobile: snowMobile
      }
    ]

    // randomnize
    return images[Math.floor(Math.random() * images.length)]
  }

  render() {
    const { showBranches, hero } = this.state

    return (
      <Container overlay={showBranches} image={hero.desktop} mobile={hero.mobile}>
        <Logo src={logo} alt="logo" />
        <Error message={`U bent momenteel al ingelogd. We zullen u nu automatisch uitloggen. Lukt dit niet, probeer dan de informatie hieronder.`} />
        <Footer type="transparent" />
      </Container>
    )
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/views/Logout/index.js